import * as FiIcons from 'react-icons/fi';

const { FiHome, FiWifi, FiSmartphone, FiZap, FiShield, FiTruck, FiMail, FiStar, FiPackage, FiGlobe, FiFileText, FiCreditCard, FiDroplet, FiShoppingCart, FiFilm, FiMusic, FiCloud, FiHeart, FiMonitor } = FiIcons;

// First matching rule wins, so specific phrases come before generic words.
const RULES = [
  { keys: ['business insurance', 'car insurance', 'auto insurance', 'insurance', 'geico', 'state farm'], icon: FiShield, tone: 'blue' },
  { keys: ['car payment', 'auto loan', 'car loan', 'car', 'vehicle', 'gas', 'fuel'], icon: FiTruck, tone: 'amber' },
  { keys: ['rent', 'mortgage', 'hoa', 'lease'], icon: FiHome, tone: 'green' },
  { keys: ['internet', 'wifi', 'wi-fi', 'comcast', 'xfinity', 'fiber'], icon: FiWifi, tone: 'blue' },
  { keys: ['phone', 'mobile', 'cell', 'verizon', 't-mobile', 'at&t'], icon: FiSmartphone, tone: 'purple' },
  { keys: ['pg&e', 'pge', 'electric', 'utilit', 'power'], icon: FiZap, tone: 'amber' },
  { keys: ['water', 'sewer'], icon: FiDroplet, tone: 'blue' },
  { keys: ['google workspace', 'gmail', 'email', 'mail', 'workspace'], icon: FiMail, tone: 'green' },
  { keys: ['chatgpt', 'openai', 'claude', 'copilot', 'ai '], icon: FiStar, tone: 'purple' },
  { keys: ['amazon', 'prime'], icon: FiPackage, tone: 'amber' },
  { keys: ['domain', 'hosting', 'website'], icon: FiGlobe, tone: 'blue' },
  { keys: ['tax', 'irs', 'accounting', 'bookkeep'], icon: FiFileText, tone: 'green' },
  { keys: ['netflix', 'hulu', 'disney', 'video', 'tv'], icon: FiFilm, tone: 'purple' },
  { keys: ['spotify', 'music', 'apple music'], icon: FiMusic, tone: 'green' },
  { keys: ['icloud', 'dropbox', 'storage', 'cloud', 'aws'], icon: FiCloud, tone: 'blue' },
  { keys: ['gym', 'health', 'medical', 'dental'], icon: FiHeart, tone: 'amber' },
  { keys: ['software', 'subscription', 'app', 'adobe'], icon: FiMonitor, tone: 'purple' },
  { keys: ['grocer', 'food', 'meal'], icon: FiShoppingCart, tone: 'green' }
];

const FALLBACK = { icon: FiCreditCard, tone: 'blue' };

export function getExpenseIcon(name) {
  const text = ` ${String(name || '').toLowerCase()} `;
  const rule = RULES.find((item) => item.keys.some((key) => text.includes(key)));
  return rule || FALLBACK;
}